import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../config/config";
import axios from "axios";

export default function PopupAuthComponent() {
  // const [showModal, setShowModal] = useState(false);
  // const [showPopup, setShowPopup] = useState(false);

  const [isGranted, setIsGranted] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/auth/me`, {
        withCredentials: true, // IMPORTANT pour envoyer les cookies HttpOnly
      })
      .then((res) => {
        if (res.status === 200) {
          setIsGranted(true);
        } else {
          setIsGranted(false);
        }
      })
      .catch(() => {
        setIsGranted(false);
      });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      // setShowModal(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  // const handleProfileClick = () => {
  //   setShowPopup(true);
  // };

  // const closePopup = () => {
  //   setShowPopup(false);
  // };

  if (!isGranted) {
    return (
      <>
        {/* {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white dark:bg-gray-800 rounded shadow-lg max-w-md w-full p-6 animate-fade-in">
            <h2 className="text-xl font-bold text-door dark:text-door-dark mb-3">
              Votre Guide Étudiant 
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Connectez-vous pour retrouver vos favoris et bénéficier d'une expérience personnalisée.<br />
              Vous n'avez pas encore de compte ? Créez-en un en quelques clics !
            </p>
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 text-sm text-gray-400  dark:hover:text-green-800 hover:text-gray-800"
              >
                Fermer
              </button>
              <a
                href="/mksp/login"
                className="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Se connecter
              </a>
              <a
                href="/mksp/register"
                className="px-4 py-2 text-sm bg-door text-white rounded hover:bg-green-700"
              >
                Créer un compte
              </a>
            </div>
          </div>
        </div>
      )} */}

        {/* Popup warning */}
        {/* {showPopup && (
         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 w-[90%] max-w-md animate-fade-in-up">
            <h2 className="text-xl dark:text-gray-200 font-semibold text-gray-800 mb-2">
              Fonctionnalité en cours
            </h2>
            <p className="text-gray-600 dark:text-gray-300">
               La section que vous souhaitez consulter est actuellement en développement afin de vous garantir une expérience optimale.
                 En attendant, profitez pleinement de notre offre gratuite et découvrez les services déjà accessibles.
            </p>
            
            <div className="mt-6 flex justify-center content-center gap-4">
              
              <button
                onClick={closePopup}
                className="px-4 py-2 bg-door text-white rounded hover:bg-door-dark transition"
              >
                OK
              </button>
             
              <a href="/mksp/guide/university"
                    className="bg-green-600 inline-flex justify-center items-center py-1 px-3 text-base font-medium text-center text-gray-100 rounded-lg border   hover:bg-green-500 focus:ring-4 focus:ring-gray-100 dark:text-white  dark:hover:bg-green-500 dark:focus:ring-gray-800 hover:bg-green-700"
                  >
                    Explorer les universités
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </a>
            
            </div>
          </div>
        </div>
      )} */}
      </>
    );
  } else {
    return;
  }
}
